import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SafeUrlPipe } from './safe-url.pipe';
@Component({
  selector: 'app-file-viewer',
  standalone: true,
  imports: [CommonModule, SafeUrlPipe, TranslateModule, ProgressSpinnerModule, PdfViewerModule],
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
})
export class FileViewerComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() fileUrl: string | null = null;
  @Input() fileName: string = '';
  @Input() downloadable: boolean = true;
  @Output() visibleChange = new EventEmitter<boolean>();

  // PDF Viewer specific options
  renderText = true;
  originalSize = false;
  showAll = true;
  autoresize = true;
  fitToPage = true;
  zoom = 1.0;
  rotation = 0;
  externalLinkTarget = '_blank';

  loading = signal<boolean>(true);

  // Total pages in the PDF
  totalPages = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['visible'] || changes['fileUrl']) && this.visible && this.fileUrl) {
      this.loading.set(true);
      this.totalPages = 0;
    }
  }

  // Handle PDF loading error
  onError(error: any): void {
    // Simply record the error but don't apply any fallback
    this.loading.set(false);
  }

  // Track when PDF is loaded successfully
  onPdfLoaded(pdf: any): void {
    this.loading.set(false);
    if (pdf) {
      this.totalPages = pdf.numPages;
    }
  }

  get fileExtension(): string {
    return this.fileName.split('.').pop()?.toLowerCase() || '';
  }

  isPdf(): boolean {
    return this.fileExtension === 'pdf';
  }

  isOffice(): boolean {
    return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(this.fileExtension);
  }
  isExcel(): boolean {
    return ['xls', 'xlsx'].includes(this.fileExtension);
  }

  getOfficeViewerUrl(): string {
    // Use Microsoft Office Online viewer for office files
    return this.fileUrl
      ? this.isExcel()
        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.fileUrl)}&wdHideSheetTabs=true&action=embedview&wdallowinteractivity=false&wdhideheaders=true&wdbipreview=true&wbdiallowTypingandFormulaEntry=true`
        : `https://docs.google.com/gview?url=${encodeURIComponent(this.fileUrl)}&embedded=true`
      : '';
  }

  onIframeLoad() {
    this.loading.set(false);
  }

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
